import { InputSwitch } from "primereact/inputswitch";
import { TabPanel, TabView } from "primereact/tabview";
import { useState } from "react";
import PrivatePresentation from "./PresentationTabComponents/PrivatePresenation";
import SharedPresentation from "./PresentationTabComponents/SharedPresentation";

const PresentationTab = () => {
  const [subTitleForAllSlides, setSubTitleForAllSlides] = useState(false);
  const [autoPlayClips, setAutoPlayClips] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="py-3 px-4 text-start">
      <div className="d-flex align-items-center gap-2">
        <div className="d-flex align-items-center gap-2">
          <span className="text-muted small">
            <span className="me-2">Subtitle for all slides</span>{" "}
            {subTitleForAllSlides ? "On" : "Off"}
          </span>
          <InputSwitch
            checked={subTitleForAllSlides}
            style={{
              height: "25px",
            }}
            onChange={(e) => {
              setSubTitleForAllSlides(e.value);
            }}
            className="custom-smooth-switch"
          />
        </div>

        <div
          className="ms-3 ps-3 d-flex align-items-center gap-2"
          style={{ borderLeft: "1px solid #d9d4d4" }}
        >
          <span className="text-muted small">
            <span className="me-2">Auto Play Clip/Images</span>{" "}
            {autoPlayClips ? "On" : "Off"}
          </span>
          <InputSwitch
            style={{
              height: "25px",
            }}
            checked={autoPlayClips}
            onChange={(e) => {
              setAutoPlayClips(e.value);
            }}
            className="custom-smooth-switch"
          />
        </div>
      </div>

      <TabView
        activeIndex={activeIndex}
        onTabChange={(e) => {
          setActiveIndex(e.index);
        }}
      >
        <TabPanel header="Private" className="tabStyle">
          <PrivatePresentation />
        </TabPanel>
        <TabPanel header="Shared">
          <SharedPresentation />
        </TabPanel>
      </TabView>

      {/* when no presentation available */}
      {/* <div className="text-center" style={{ padding: "10%", fontSize: "22px" }}>
        <i
          className="pi pi-desktop mb-3"
          style={{ fontSize: "150px", color: "#eeeeee" }}
        ></i>
        <p>
          Use the Presentation Builder widget in the Visual Analysis tab to
          create slides and add clips/images. Once done you will be able to
          review and edit your presentation here.
        </p>
      </div> */}
    </div>
  );
};

export default PresentationTab;
